import { PHOTO_PACK_CATALOG, type PhotoPackTier } from "@/src/core/domain/types";

export function getPhotosPerRound(): number {
  const raw = process.env.PHOTOS_PER_ROUND;
  const parsed = raw ? Number(raw) : 6;
  return Number.isFinite(parsed) && Number.isInteger(parsed) && parsed > 0 ? parsed : 6;
}

export function roundsForTier(tier: PhotoPackTier): number {
  return PHOTO_PACK_CATALOG[tier].rounds;
}

export function photosForTier(tier: PhotoPackTier): number {
  return roundsForTier(tier) * getPhotosPerRound();
}

